import React, { lazy, useEffect, useState } from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link, Outlet, useNavigate } from "react-router-dom";

// Components
import {
  Header,
  HeaderCart,
  HeaderLanguage,
  HeaderNav,
  Menu,
  SearchBar,
  Topbar,
} from "../Components/Header/Header";
import FooterMenu, { Footer } from "./Footer";
import FooterStyle01 from "../Components/Footers/FooterStyle01";
import HeaderToolbar from "../Components/Header/HeaderToolbar";
import NewHeader from "../Components/Header/new-header/NewHeader";
import SocialIcons from "../Components/SocialIcon/SocialIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import WhatsAppFloatingButton from "./ecd-pages/WhatsAppFloatingButton ";
import CartIcon from "../Components/Header/CartIcon";
import CartDrawer from "./meldi-dham-pages/product/CartDrawer";
import LoginPage from "./meldi-dham-pages/auth-pages/LoginPage";
import { useDispatch } from "react-redux";
import { clearCart } from "../store/cartSlice";
import { toast } from "react-toastify";
import LogoutConfirmationModal from "./meldi-dham-pages/auth-pages/LogoutConfirmationModal";
import { getTranslatedHeaderData } from "../Components/Header/new-header/NewHeaderData";
import FooterData from "../Components/Footers/FooterData";
import useHeaderData from "../Components/Header/new-header/useHeaderNavData";
const SideButtons = lazy(() => import("../Components/SideButtons"));

const iconData = [
  {
    color: "#5c42eeff",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f",
  },
  {
    color: "#566ac2ff",
    link: "https://dribbble.com/",
    icon: "fab fa-dribbble",
  },
  {
    color: "#23a2ddff",
    link: "https://twitter.com/",
    icon: "fab fa-twitter",
  },
  {
    color: "#e92671ff",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram",
  },
];
const ElementPage = (props) => {
  const { t, i18n } = useTranslation();
  const [showCart, setShowCart] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [customer, setCustomer] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseMenu = getTranslatedHeaderData(t);

  const headerItems = useHeaderData(t); // <-- IMPORTANT
  const footerMenu = headerItems.filter((item) => item.key !== "services");
  useEffect(() => {
    const session = localStorage.getItem("customer"); // ✅ sessionStorage
    setCustomer(session ? JSON.parse(session) : null);
  }, []);
  // -------------------------------------------------

  const [showModal, setShowModal] = useState(false);
  const handleLogout = () => {
    setShowModal(true);
  };
  const confirmLogout = () => {
    setShowModal(false);
    localStorage.removeItem("customer");
    localStorage.removeItem("checkoutAddress");
    dispatch(clearCart());
    navigate("/page/products", { replace: true });
    console.log("User logged out");
  };

  const cancelLogout = () => {
    setShowModal(false);
  };
  return (
    <>
      {/* Header Start */}
      <Header
        topSpace={{ desktop: true }}
        type="reverse-scroll"
        className="header-with-topbar bg-[#ffffff] border-b border-[#0000001a] "
      >
        {/* <Topbar className="home-business-topbar border-[#0000001a] sm:hidden"> */}
        <Topbar className="home-business-topbar border-[#0000001a]">
          <Container fluid>
            {/* <Container> this is use space both side in line toolbar */}
            <Row className="justify-between items-center majer-project">
              <HeaderToolbar />
            </Row>
          </Container>
        </Topbar>
        <HeaderNav
          fluid="fluid"
          theme="light"
          // bg="white"
          menu="light"
          containerClass="sm:px-0 pe-0"
          className="px-[35px] py-[0px] md:pr-[15px] md:pl-0 px-0"
          style={{ backgroundColor: "#ffffff" }}
        >
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link
              aria-label="header logo"
              className="d-flex align-items-center"
              to="/"
            >
              <div className="p-1 m-1">
                {/* Desktop & Laptop logo */}
                <img
                  className="default-logo img-fluid d-none d-md-block"
                  loading="lazy"
                  src="/assets/logo/Neevo-small.png"
                  alt="logo"
                  style={{ maxWidth: "250px" }}
                />

                {/* Tablet logo */}
                <img
                  className="alt-logo img-fluid d-none d-sm-block d-md-none"
                  loading="lazy"
                  src="/assets/logo/Neevo-small.png"
                  alt="logo"
                  style={{ maxWidth: "250px", height: "auto" }}
                />

                {/* Mobile logo */}
                <img
                  className="mobile-logo img-fluid d-block d-sm-none"
                  loading="lazy"
                  src="/assets/logo/Neevo-small.png"
                  alt="logo"
                  style={{ maxWidth: "80px" }}
                />
              </div>
            </Link>
          </Col>
          <Col className="col-auto text-start hidden-xs font-size-0 !pl-[12px]" />
          <Navbar.Toggle className="order-last md:mx-[15px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="col-auto justify-end p-0">
            <Menu {...props} />
          </Navbar.Collapse>
          {/* <HeaderCart className="pe-2" /> */}

          {/* <CartIcon className="pe-2" onClick={() => setShowCart(true)} /> */}
          <CartDrawer show={showCart} onHide={() => setShowCart(false)} />
          {/* {!customer ? (
            <button
              className="btn btn-danger bg-red-600 me-2 hover:bg-white hover:text-red-600 transition-colors"
              // style={{ backgroundColor: "#4c934c", color: "white", }}
              onClick={() => setShowLogin(true)}
            >
              Login
            </button>
          ) : (
            <strong
              className="text-dark me-2 cursor-pointer"
              onClick={handleLogout}
            >
              👤{customer.firstName} {customer.lastName}
            </strong>
          )} */}
          <LoginPage show={showLogin} onHide={() => setShowLogin(false)} />
          <LogoutConfirmationModal
            show={showModal}
            onConfirm={confirmLogout}
            onCancel={cancelLogout}
          />
        </HeaderNav>
      </Header>
      {/* Header End */}
      <Outlet />

      {/*  Footer Start */}
      {/* <FooterStyle01 theme="dark" className="bg-[#4c934c] text-slateblue" /> */}

      <footer className="bg-[#ffffff] text-dark border-t border-gray-300 pt-3 pb-3">
        <div className="container">
          <Row className="align-items-start gy-4">
            {/* Logo Column */}
            <Col md={6} lg={6} sm={12} className="text-center text-md-start">
              <Link
                aria-label="footer logo"
                className="d-inline-flex align-items-center"
                to="/"
              >
                <img
                  src="/assets/logo/Neevo-small.png"
                  alt="Neev Organic Haat Logo"
                  loading="lazy"
                  className="img-fluid"
                  style={{ maxWidth: "200px" }}
                />
              </Link>
              <p className="fw-semibold text-dark">
                <i className="feather-phone-call me-2 text-dark" />
                +91 97129 24365 <br />
                <i className="feather-mail me-2 text-dark" />
                info@neevorganichaat.com <br />
                {/* <small className="text-dark">(સેવક નીવ ઓર્ગેનિક હાટ)</small> */}
                {/* <small className="text-dark">( {t("conectwith")} )</small> */}
              </p>
              <ul className="text-start mt-4">
                <button
                  className="btn btn-sm me-2 rounded"
                  style={{ backgroundColor: "#31572c", color: "#ffffff" }}
                >
                  <Link to="/why-choose">
                    {t("whyChooseUs.whyChooseUsTitle")}
                  </Link>
                </button>
              </ul>
            </Col>
            <Col lg={3} md={3} sm={12} className="text-center text-md-start">
              <ul className="list-style">
                {footerMenu.map((item, index) => (
                  <li key={index} className="mb-2">
                    <Link
                      to={item.link}
                      className="text-blue hover:text-blue-700 underline uppercase"
                    >
                      {t(item.title)}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>
            {/* Social Column */}
            <Col lg={3} md={3} sm={12} className="text-md text-center">
              <p className="text-uppercase fw-bold mb-4 fs-6 text-dark">
                {t("follow")}
              </p>
              <SocialIcons
                size="sm"
                // theme="social-icon-style-01"
                className="justify-md-center justify-center text-dark"
                iconColor={props.theme === "dark" ? "dark" : "dark"}
                data={iconData}
              />
              {/* <div className="text-center py-5 border-top border-white">
                <p className="mb-0 text-dark">
                  © {new Date().getFullYear()} {t("reserved")}.
                </p>
                <a
                  href="https://agmetech.com"
                  target="_blank"
                  rel="noreferrer"
                  className="cursor-pointer"
                >
                  {" "}
                  {t("developed_by")}
                </a>
              </div> */}
            </Col>
            {/* <Col lg={1} md={1} sm={12} className="text-center text-md-start" /> */}
            {/* Contact Column */}

            <WhatsAppFloatingButton />
          </Row>
        </div>
        <div className="text-center py-2 border-top border-gray-300">
          <p className="mb-0 text-dark">
            © {new Date().getFullYear()} {t("reserved")}.
          </p>
          <a
            href="https://agmetech.com"
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer"
          >
            {" "}
            {t("developed_by")}
          </a>
        </div>
      </footer>
      {/*  Footer End */}
    </>
  );
};

export default ElementPage;
